const ColorPickerItem = ({ colorHex, handleNewColor }: any) => {
  return (
    <div className="w-[24px] h-[24px] border-2 border-solid border-lightgrey rounded-full hover:border-blueselected cursor-pointer">
      <div
        onClick={() => handleNewColor(colorHex)}
        className="border border-solid border-white w-full h-full rounded-full"
        data-color={colorHex}
        style={{ backgroundColor: colorHex }}
      ></div>
    </div>
  );
};
export default ColorPickerItem;
